(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["taana-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tl-read-more')) {
    class TlReadMore extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('.tl-desc__body');
        this.button = this.querySelector('.tl-desc__toggle');
        if (!this.body || !this.button) return;
        this.onClick = () => this.toggle();
        this.button.addEventListener('click', this.onClick);
        this.measure();
        if ('ResizeObserver' in window) {
          this.lastWidth = 0;
          this.observer = new ResizeObserver((entries) => {
            const width = Math.round(entries[0].contentRect.width);
            if (width !== this.lastWidth) {
              this.lastWidth = width;
              this.measure();
            }
          });
          this.observer.observe(this);
        }
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.measure());
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
      }

      lineHeight() {
        const sample = this.body.querySelector('p, li') || this.body;
        const style = getComputedStyle(sample);
        const lh = parseFloat(style.lineHeight);
        return Number.isFinite(lh) ? lh : parseFloat(style.fontSize) * 1.6;
      }

      measure() {
        if (this.classList.contains('is-expanded')) return;
        const lines = parseFloat(getComputedStyle(this).getPropertyValue('--tl-desc-lines')) || 7;
        const lh = this.lineHeight();
        const max = Math.round(lh * lines);
        this.style.setProperty('--tl-desc-lh', lh + 'px');
        this.style.setProperty('--tl-desc-max', max + 'px');
        const needsClamp = this.body.scrollHeight > max + lh * 0.75;
        this.classList.toggle('is-clamped', needsClamp);
        this.body.style.maxHeight = '';
      }

      toggle() {
        const expand = !this.classList.contains('is-expanded');
        const label = this.button.dataset[expand ? 'labelLess' : 'labelMore'];
        if (expand) {
          this.body.style.maxHeight = this.body.offsetHeight + 'px';
          this.classList.remove('is-clamped');
          this.classList.add('is-expanded');
          requestAnimationFrame(() => {
            this.body.style.maxHeight = this.body.scrollHeight + 'px';
          });
          const done = () => {
            if (this.classList.contains('is-expanded')) this.body.style.maxHeight = 'none';
            this.body.removeEventListener('transitionend', done);
          };
          this.body.addEventListener('transitionend', done);
          window.setTimeout(done, 700);
        } else {
          this.body.style.maxHeight = this.body.scrollHeight + 'px';
          requestAnimationFrame(() => {
            this.classList.remove('is-expanded');
            this.measure();
            this.body.style.maxHeight = '';
          });
          const top = this.getBoundingClientRect().top;
          if (top < 0) window.scrollBy({ top: top - 120, behavior: 'smooth' });
        }
        this.button.setAttribute('aria-expanded', String(expand));
        if (label) this.button.setAttribute('aria-label', label);
      }
    }
    customElements.define('tl-read-more', TlReadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
